export abstract class KioskStorageConfiguration {
  static readonly KIOSK_ID = "kioskId";
  static readonly SECURITY_PIN = "securityPin";
  /**
   * Indicates if the kiosk is in demo mode.
   * If true, the kiosk will not connect to POS system and will not process 'real' orders.
   * This is useful for testing purposes.
   */
  static readonly DEMO_MODE = "demoMode";
}
